"use client";

import { interpolate, useCurrentFrame, useVideoConfig } from "remotion";

export default function CameraShake() {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();

  // Amplitude decays from ~15px to 0 over the duration
  const amplitude = interpolate(frame, [0, durationInFrames], [15, 0], {
    extrapolateRight: "clamp",
  });

  // Organic shake using multiple sine/cosine frequencies
  const shakeX = Math.sin(frame * 0.8) * amplitude;
  const shakeY = Math.cos(frame * 1.1) * amplitude;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: "#111827",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Content card that shakes */}
      <div
        style={{
          transform: `translate(${shakeX}px, ${shakeY}px)`,
          background: "linear-gradient(135deg, #1e293b, #0f172a)",
          border: "1px solid rgba(59, 130, 246, 0.3)",
          borderRadius: "16px",
          padding: "2.5rem 3rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxShadow: "0 0 40px rgba(59, 130, 246, 0.15)",
        }}
      >
        <h1
          style={{
            color: "white",
            fontSize: "3.5rem",
            fontWeight: "bold",
            margin: 0,
            letterSpacing: "0.15em",
          }}
        >
          IMPACT
        </h1>
        <div
          style={{
            width: "60px",
            height: "3px",
            background: "linear-gradient(90deg, #3b82f6, #a855f7)",
            margin: "1rem 0",
            borderRadius: "2px",
          }}
        />
        <p
          style={{
            color: "#93c5fd",
            fontSize: "1.1rem",
            margin: 0,
            textAlign: "center",
          }}
        >
          Camera shake with decaying amplitude
        </p>
      </div>
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
